import { useEffect } from "react";
import { useAuth } from "./AuthContext";

const LOGOUT_EVENT_KEY = "httrader_supplier_portal_logout";
let alreadyLoggedOutInThisTab = false;

const CrossTabLogoutSync: React.FC = () => {
  const { idToken, logOut } = useAuth();

  useEffect(() => {
    function handleStorageEvent(event: StorageEvent) {
      if (
        event.key === LOGOUT_EVENT_KEY &&
        !!idToken &&
        !alreadyLoggedOutInThisTab
      ) {
        alreadyLoggedOutInThisTab = true;
        logOut();
      }
    }
    window.addEventListener("storage", handleStorageEvent);
    return () => {
      window.removeEventListener("storage", handleStorageEvent);
    };
  }, [logOut, idToken]);

  return null;
};

export default CrossTabLogoutSync;
